(function () {
  function openTopLevel() {
    const drawer = document.querySelector('#Drawer-MobileNav');
    if (!drawer) return;

    // Items nivel 1 con hijos
    const items = drawer.querySelectorAll('li.f-mobile-nav__item--has-child');

    items.forEach((li) => {
      // El tema controla el estado con aria-expanded en el trigger
      const trigger = li.querySelector('[data-trigger]');
      if (!trigger) return;

      const expanded = trigger.getAttribute('aria-expanded') === 'true';
      if (!expanded) trigger.click(); // <-- esto es lo que realmente “abre” en Zest
    });
  }

  function bind() {
    const drawer = document.querySelector('#Drawer-MobileNav');
    if (!drawer) return;

    // Cuando se abre el drawer (evento del componente)
    drawer.addEventListener('open', () => setTimeout(openTopLevel, 80));

    // Y por si el tema no dispara ese evento, observamos cambios
    const obs = new MutationObserver(() => {
      const isOpen = drawer.hasAttribute('open') && !drawer.hasAttribute('hidden');
      if (isOpen) setTimeout(openTopLevel, 80);
    });

    obs.observe(drawer, { attributes: true, attributeFilter: ['open', 'hidden'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
